import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["isExternalLink"];
import { createContext, useCallback, useContext, useMemo } from 'react';
import { track } from 'quartz-tracking/service';
import { USAGE_TRACKER_NAMESPACE } from 'academy-common-lib/constants/general';
import { jsx as _jsx } from "react/jsx-runtime";
const TrackingContext = /*#__PURE__*/createContext(null);
export const TrackingProvider = ({
  publicId,
  language,
  type,
  enabled,
  children
}) => {
  const trackEvent = useCallback(_ref => {
    let extra = _objectWithoutPropertiesLoose(_ref, _excluded);
    if (!enabled) return;
    track('Learning Center', 'Public Achievement Interaction', Object.assign({
      namespace: USAGE_TRACKER_NAMESPACE,
      publicId,
      language,
      template: 'SINGLE_CERT',
      type
    }, extra));
  }, [language, publicId, type, enabled]);
  const value = useMemo(() => trackEvent, [trackEvent]);
  return /*#__PURE__*/_jsx(TrackingContext.Provider, {
    value: value,
    children: children
  });
};
export function useTrackEvent() {
  const trackEvent = useContext(TrackingContext);
  if (!trackEvent) {
    throw new Error('useTrackEvent must be used within a TrackingProvider');
  }
  return trackEvent;
}